var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoUdaSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 18,
    viewBox: "0 0 13 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.59502 1.02282C6.54246 0.992243 6.47793 0.992403 6.42552 1.02324L1.08793 4.16409C1.03355 4.19472 0.999846 4.25311 1 4.31645C1.00507 6.3866 1.01586 10.5894 1.01586 10.5894C1.02026 10.6461 1.05173 10.6973 1.10053 10.726C1.10175 10.7267 1.10298 10.7274 1.10421 10.7281C4.67341 12.8056 8.2126 14.8984 11.7822 16.9755C11.8349 17.0062 11.8996 17.0059 11.9521 16.9749C12.0045 16.9438 12.0368 16.8866 12.0368 16.8248C12.0368 12.6459 12.0398 8.46448 12.0398 4.2856C12.0398 4.22328 12.007 4.16575 11.9539 4.13486L6.59502 1.02282ZM6.37081 7.73297L1.5279 10.575L6.37081 13.3939L6.37081 7.73297ZM1.34119 4.60643L6.19876 7.43337L1.35507 10.2759L1.34119 4.60643ZM6.71135 13.3922L11.5511 10.5489L6.71135 7.73211L6.71135 13.3922ZM6.88273 7.43202L11.7001 4.59484L11.7217 10.2484L6.88273 7.43202ZM11.5353 4.29095L6.51111 1.37368L1.52007 4.31082L6.54051 7.23254L11.5353 4.29095ZM11.6963 16.5259L6.88337 13.6921L11.7375 10.8484L11.6963 16.5259Z",
    fill: "#212632",
    stroke: "#212632",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoUdaSymbol);
export default __webpack_public_path__ + "static/media/logo-uda-symbol.0eff554e3e1caa79dd5c80c0ef5b560d.svg";
export { ForwardRef as ReactComponent };